import { render, staticRenderFns } from "./vSelect.vue?vue&type=template&id=06228977&scoped=true"
import script from "./vSelect.vue?vue&type=script&lang=ts"
export * from "./vSelect.vue?vue&type=script&lang=ts"
import style0 from "./vSelect.vue?vue&type=style&index=0&id=06228977&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06228977",
  null
  
)

export default component.exports